module.exports = __webpack_public_path__ + "static/media/wr.53770f4e.svg";